import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SeFeModalButton, SeFeModalCloseSource, SeFeModalComponent } from 'se-fe-modal';
import { Registration } from '../models/registration.model';

@Component({
  selector: 'app-registration-warning-modal',
  standalone: false,
  templateUrl: './registration-warning-modal.component.html',
  styleUrls: ['./registration-warning-modal.component.scss'],
})
export class RegistrationWarningModalComponent implements OnDestroy {
  private readonly modal = viewChild.required(SeFeModalComponent);

  public readonly actions: SeFeModalButton[];
  public isOpen = false;
  public registrations: Registration[] = [];

  private readonly closeOnOutsideClick = (event: MouseEvent): void => {
    if (this.modal().containerRef.contains(event.target as Node)) {
      return;
    }

    this.close(undefined, 'backdrop');
  };

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private changeDetectorRef: ChangeDetectorRef,
    private translateService: TranslateService
  ) {
    this.actions = [
      {
        label: '',
        primary: true,
        action: (_checked, triggerEl, source) => this.close(triggerEl, source),
      },
    ];
  }

  public open(registrations: Registration[], triggerEl: HTMLElement): void {
    this.registrations = registrations;
    this.actions[0].label = this.translateService.instant('LIST_VIEW.REGISTRATION_WARNING_MODAL.understand');
    this.changeDetectorRef.detectChanges();
    this.modal().open(triggerEl);
    this.isOpen = true;
    this.document.addEventListener('mousedown', this.closeOnOutsideClick, true);
  }

  public close(triggerEl?: HTMLElement | null, source?: SeFeModalCloseSource): void {
    this.modal().close(triggerEl, source);
  }

  public ngOnDestroy(): void {
    this.onModalClosed();
  }

  public onModalClosed(): void {
    this.isOpen = false;
    this.document.removeEventListener('mousedown', this.closeOnOutsideClick, true);
  }
}
